import { useQuery, UseQueryResult } from 'react-query'
import { FetchNonApiWholesalesResult } from './types'
import { fetchNonApiWholesales } from './services'

export default function useNonApiWholesalesQuery(): UseQueryResult<FetchNonApiWholesalesResult> {
   return useQuery('nonApiWholesales', fetchNonApiWholesales, { staleTime: 60 * (60 * 1000) })
}
